export const logger = {
    info: (tag = 'default', ...message) => {
        log('log', tag, ...message);
    },
    warn: (tag = 'default', ...message) => {
        log('warn', tag, ...message);
    },
    error: (tag = 'default', ...message) => {
        log('error', tag, ...message);
    }
};

function log(level, tag, ...message) {
    // controlla che il tag sia attivo nel localStorage
    let activeTags = localStorage.getItem('log.tags');
    if (activeTags) {
        activeTags = activeTags.split(',');
        if (!activeTags.includes(tag)) {
            return;
        }
    }

    if(process.env.NODE_ENV === 'production') {
        // In production, we only log errors
        if (level !== 'error') {
            return;
        }
    }

    if (tag) {
        tag = '[' + tag + ']';
        console[level](tag, ...message);
    } else {
        console[level](...message);
    }
}

export default {
    install: (app, options) => {
        app.provide('logger', logger);
    }
}